import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=e416a870&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=e416a870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e416a870",
  null
  
)

export default component.exports